
export default {
    name: "cancelConfirmPop",
    data(){
        return {
            dialogVisible: false,
            goodsData:null,
        }
    },
    methods: {
        handleClose(){
            this.dialogVisible = false;
        },
        openDialog(data){
            this.goodsData = data
            this.dialogVisible = true;
        },
        async onUnBind(){
            const {goodsNo,goodsUnionNo} = this.goodsData
            const res = await this.$api.unionUnBindApi({goodsNo,goodsUnionNo})
            if(!res.success){
                this.$message.error(res.info)
            }
            this.handleClose()
            this.$emit('onUnBind',this.goodsData)
        }
    }
}
